<template>
    <div>
        <loading v-show="loading"></loading>
        <div v-show="!loading">
            <select-menu v-model="local"
                         :text="users.map(u => u.text)"
                         :values="users.map(u => u.id)">
                User
            </select-menu>
            <slot>Schreibtische auf einen bestimmen User buchen.</slot>
        </div>
    </div>
</template>

<script>
import Loading from "./UI/Loading.vue";
import SelectMenu from "./UI/SelectMenu.vue";

export default {
    name: "UserSelect",

    components: {
        SelectMenu,
        Loading,
    },

    props: ['value'],

    data: () => ({
        loading: true,
        users: [],
    }),

    mounted() {
        this.getUsers();
    },

    computed: {
        local: {
            set(value) {
                this.$emit('input', value);
            },
            get() {
                return this.value;
            },
        },
    },

    methods: {
        getUsers() {
            this.loading = true;
            this.$http
                .get('/admin/users')
                .then(result => {
                    this.users = [{
                        id: null,
                        text: '-',
                    }].concat(result.data.data.sort((a, b) => a.name.localeCompare(b.name)).map(u => ({
                        id: u.id,
                        text: `${u.first_name} ${u.name}`,
                    })));
                    this.loading = false;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
